<div class="blue nav-fr">
    <a href="https://ecell.in/" style="text-align: left;"><img class="ecell-logo" src="https://eureka2022.s3.ap-south-1.amazonaws.com/E-logo.png" style="width: 50px; justify-self: start;"></a>
    <!-- <app-navbar></app-navbar> -->
    <h1>Eureka! 22 Pitching Competition</h1>
    <img class="college-logo" src="https://eureka2022.s3.ap-south-1.amazonaws.com/riac+logo.png" style="width: 50px; justify-self: end;">
</div>
<style>
    .mat-horizontal-stepper-header .mat-step-icon{
        display: none !important;
    }
    .mat-horizontal-stepper-header-container{
        display: none;
    }
    
</style>

<div class="white">

    <!-- <mat-horizontal-stepper #stepper> -->
<!-- <mat-stepper [linear]="isLinear" #stepper>
  <mat-step [stepControl]="firstFormGroup"> -->
    <form [formGroup]="firstFormGroup"  class="blue main-form">
      <!-- <ng-template matStepLabel>Register</ng-template> -->
      <h3>Register</h3>
      <!-- <mat-form-field class="input-field">
        <mat-label class="input-label">Full Name</mat-label>
        <mat-select>
          <mat-option *ngFor="let brand of brands" [value]="brand.value">
            {{ brand.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
      <br>
      <mat-form-field class="input-field">
        <mat-label class="input-label"> Full Name</mat-label>
        <input matInput placeholder="Name" formControlName="name" required>
        <mat-error *ngIf="firstFormGroup.controls['name'].hasError('required')">
            Name is required!
        </mat-error>
      </mat-form-field><br>
      <mat-form-field  class="input-field">
        <mat-label class="input-label">Email ID</mat-label>
        <input matInput placeholder="Email"  name="email" pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"  formControlName="email" required>
        <mat-error *ngIf="firstFormGroup.controls['email'].hasError('required')">
            Email is required!
        </mat-error>
        <mat-error *ngIf="firstFormGroup.controls['email'].hasError('email')">
        Email is not Valid!
    </mat-error>
      </mat-form-field><br>
      <!-- <mat-form-field  class="input-field">
        <mat-label class="input-label">Gender</mat-label>
        <mat-select formControlName="gender">
          <mat-option *ngFor="let gender of gender" [value]="gender.value">
            {{ gender.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field><br> -->
      <!-- <mat-form-field  class="input-field">
        <mat-label class="input-label">Country</mat-label>
        <mat-select formControlName="country">
          <mat-option *ngFor="let country of country" [value]="country.value">
            {{ country.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
      <!-- <mat-form-field  class="input-field">
        <mat-label class="input-label">Contact Number</mat-label>
        <input matInput placeholder="Contact" formControlName="email" required>
      </mat-form-field> -->
      <br>
      <mat-form-field  class="input-field">
        <mat-label class="input-label">Contact Number (Country Code mandatory)</mat-label>
        <input matInput placeholder="Contact" name="contact" pattern="[0-9+]{13,13}" formControlName="contact" required >
        <mat-error *ngIf="firstFormGroup.controls['contact'].hasError('required')">
            Mobile is required!
        </mat-error>
     <mat-error *ngIf="firstFormGroup.controls['contact'].hasError('min')">
            Mobile No is Wrong!
        </mat-error>
      </mat-form-field>
      <br/>
      <mat-form-field class="input-field">
        <mat-label class="input-label">No. of Team members</mat-label>
        <input matInput placeholder="No. of Team members" name="members" pattern="[0-9]{1,3}" formControlName="members" required>
        <mat-error *ngIf="firstFormGroup.controls['contact'].hasError('required')">
          Member count is required!
      </mat-error>
      </mat-form-field><br>
      <mat-form-field class="input-field">
        <mat-label class="input-label">Idea Name</mat-label>
        <input matInput placeholder="Idea Name" formControlName="idea">
      </mat-form-field><br>
      <mat-form-field class="input-field">
        <mat-label class="input-label">Idea Description</mat-label>
        <input matInput placeholder="Idea Description" formControlName="idea_desc">
      </mat-form-field><br>
      <!-- <mat-form-field   class="input-field">
        <mat-label class="input-label">Set your team password</mat-label>
        <input matInput formControlName="password"  placeholder="Enter your password" [type]="hide ? 'password' : 'text'"  name="password">
        <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
      </mat-form-field> -->
    
      <!-- <mat-form-field  class="input-field">
        <mat-label class="input-label">Password</mat-label>
        <input matInput placeholder="Password" name="password" formControlName="password" required>
      </mat-form-field> -->
      <br>
      <!-- <mat-form-field class="input-field">
        <mat-label class="input-label">From where did you hear about Eureka! 2022?*</mat-label>
        <mat-select formControlName="source">
          <mat-option *ngFor="let sources of sources" [value]="sources.value">
            {{ sources.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field><br>
      <mat-form-field  class="input-field">
        <mat-label class="input-label">Referral ID (If any)</mat-label>
        <input matInput placeholder="Referral ID" formControlName="referral">
      </mat-form-field> -->
      <div>
        <!-- <button class="green-button" mat-button matStepperPrevious>Back</button> -->
        <!-- <button class="green-button" mat-button (click)="stepper.reset()">Reset</button> -->
        <button class="green-button" mat-button (click)="submit()">Submit</button>
      </div>
      
    </form>
  <!-- </mat-step>
  
</mat-stepper> -->

</div>

<!-- <app-footer></app-footer> -->